// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'caret-left';

export const Component = () => <path d='M17.25 21H14.5L8 12.5 14.5 4h2.75l-6.5 8.5z' />;

export const viewBox = '0 0 25 25';
